/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-filename-extension */
import { I18n } from '@bingads-webui-grid/well-known';
import React, { FC, Fragment, useRef, useState } from 'react';
import { anchorHrefPlaceholder } from '../utils';
import { ProductOffersCallout } from './ProductOffersCallout';
import { Model$Listing } from '../../ApiType';

interface FlattenConditionTemplateProps {
  path: string;
  Attribute: string;
  i18n: I18n;
  partitionFullPath: Array<Model$Listing>;
  scope: {
    values: {
      campaignId: string | number;
    };
    save: Function;
  };
  productListingGroupId: number;
  assetGroupId: number | undefined;
}

export const FlattenConditionTemplate: FC<FlattenConditionTemplateProps> = (props) => {
  const {
    path, Attribute, i18n, partitionFullPath, scope, productListingGroupId, assetGroupId,
  } = props;
  const attributeRef = useRef(null);
  const [showCallout, setShowCallout] = useState<boolean>(false);
  let hideCalloutTimer: number | undefined;
  const slowHideCallout = () => {
    hideCalloutTimer = window.setTimeout(() => {
      setShowCallout(false);
    }, 300);
  };

  const updatedScope = {
    values: {
      ...scope.values,
      assetGroupId,
    },
    save: scope.save,
  };

  const closeTooltip: React.KeyboardEventHandler<HTMLSpanElement> = (e) => {
    if (e.key === 'Escape') {
      setShowCallout(false);
    }
    e.stopPropagation();
  };

  return (
    <Fragment>
      {
        <div className="grid-cell listing-group-condition-cell">
          <div><span className="flatten-path">{path}</span></div>
          <div>
            <div className="attributeContainer" onMouseEnter={() => clearTimeout(hideCalloutTimer)} onMouseLeave={() => slowHideCallout()}>
            {
              // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
              <a ref={attributeRef} onMouseOver={() => setShowCallout(true)} onFocus={() => setShowCallout(true)} onKeyDown={e => closeTooltip(e)} onBlur={() => setShowCallout(false)} href={anchorHrefPlaceholder} className="listing-group-name-container" aria-label={Attribute}>
                {Attribute}
              </a>
            }
            { showCallout && <ProductOffersCallout target={attributeRef} i18n={i18n} fullPath={partitionFullPath} scope={updatedScope} productListingGroupId={productListingGroupId} /> }
            </div>
          </div>
        </div>}
    </Fragment>);
};
